import React, { useMemo, useState } from 'react';
import FilterSearchGroup from '../../../../Common/FilterSearchGroup';
import ReactSelect from '../../../../Common/Select';
import { InputGroup, InputWrap, SelectGroup, SearchWrap } from '../../../../Common/FilterSearchGroup/Components/Part';
import TextInput from '../../../../Common/Input/TextInput';
import Button from '../../../../Common/Button';
import useTranslation from '../../../../../util/hooks/useTranslation';
import DatePicker from '../../../../Common/DatePicker';
import SearchGroup from '../../../../Common/FilterSearchGroup/Components/SearchGroup';
import SearchButtonArea from '../../../../Common/FilterSearchGroup/Components/SearchButtonArea';

const Search = ({ getLoginLogList }) => {
    const t = useTranslation('Login History Log');

    const typeOptions = useMemo(() => {
        return [
            { value: '', label: t('Log Type') },
            { value: 'F', label: t('Failure') },
            { value: 'S', label: t('Success') },
        ];
    }, [t]);

    const searchOptions = useMemo(() => {
        return [
            { value: '', label: t('Search Option', 'Search') },
            { value: 'ip', label: t('IP') },
            { value: 'regDate', label: t('Date') },
        ];
    }, [t]);

    const [selectedTypeOption, setSelectedTypeOption] = useState(typeOptions[0]);
    const [searchInput, setSearchInput] = useState('');
    const [searchInputDisabled, setSearchInputDisabled] = useState(true);
    const [selectedOption, setSelectedOption] = useState(searchOptions[0]);
    const [date, setDate] = useState(null);

    const handleRefreshClick = e => {
        setSelectedTypeOption(typeOptions[0]);
        setSelectedOption(searchOptions[0]);

        setSearchInput('');
        setDate(null);

        setSearchInputDisabled(true);
        getLoginLogList();
    };

    const handleSearchClick = () => {
        if (selectedOption) {
            getLoginLogList({
                type: selectedTypeOption.value,
                opt: selectedOption.value,
                keyword: selectedOption && selectedOption.value === 'ip' ? searchInput : date,
            });
        } else {
            getLoginLogList({
                type: selectedTypeOption.value,
            });
        }
    };

    const handleSelectValueChange = value => {
        setSelectedOption(value);
        if (value.value !== '') {
            setSearchInputDisabled(false);
        } else {
            setSearchInputDisabled(true);
            setSearchInput('');
        }
    };

    const handleInputChange = e => {
        const { value } = e.target;
        setSearchInput(value);
    };

    return (
        <FilterSearchGroup>
            <SearchGroup className={'bg-brand'} label={t('Search', 'Search')}>
                <div style={{ width: '10rem' }}>
                    <ReactSelect
                        name={'manipulationType'}
                        placeholder={t('Log Type')}
                        value={selectedTypeOption}
                        options={typeOptions}
                        onChange={selected => setSelectedTypeOption(selected)}
                        customControlStyles={{
                            width: '100%',
                        }}
                        customMenuStyles={{ width: '100%' }}
                        customOptionStyles={{ width: '100%' }}
                    />
                </div>
                <SearchWrap>
                    <SelectGroup>
                        <ReactSelect
                            name={'selectInput'}
                            placeholder={t('Search Option', 'Search')}
                            value={selectedOption}
                            options={searchOptions}
                            onChange={handleSelectValueChange}
                            customControlStyles={{
                                width: '100%',
                            }}
                            customMenuStyles={{ width: '100%' }}
                            customOptionStyles={{ width: '100%' }}
                        />
                    </SelectGroup>
                    <InputWrap>
                        <InputGroup>
                            {!selectedOption || selectedOption.value === 'regDate' ? (
                                <div className={'datePicker-container'}>
                                    <DatePicker
                                        value={date}
                                        handleChange={selected => setDate(selected)}
                                        maxDate={new Date()}
                                        withoutTime
                                    />
                                </div>
                            ) : (
                                <TextInput
                                    style={{ borderRadius: '5px' }}
                                    type={'text'}
                                    size={'60'}
                                    placeholder={t(
                                        'Please Enter your search keyword after selecting search option.',
                                        'Search',
                                    )}
                                    name={'name'}
                                    value={searchInput}
                                    handleChange={handleInputChange}
                                    disabled={searchInputDisabled}
                                />
                            )}
                        </InputGroup>
                    </InputWrap>
                </SearchWrap>
                <SearchButtonArea>
                    <Button className={'btn-brand btn-icon'} iconClassName={'icon-search'} onClick={handleSearchClick}>
                        {t('Search', 'Search')}
                    </Button>
                    <Button
                        className="btn-danger btn-icon-only"
                        iconClassName={'icon-replay'}
                        onClick={handleRefreshClick}
                    />
                </SearchButtonArea>
            </SearchGroup>
        </FilterSearchGroup>
        //     search={{
        //         label: t('Search', 'Search'),
        //         body: (
        //             <>
        //
        //             </>
        //         ),
        //         action: (
        //             <Button
        //                 className="btn-danger btn-icon-only"
        //                 iconClassName={'icon-replay'}
        //                 onClick={handleRefreshClick}
        //             />
        //         ),
        //     }}
        // />
    );
};

export default Search;
